// Utility functions for input validation

// Email validation using regex
export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Password validation
export const isValidPassword = (password) => {
  // At least 8 characters, 1 uppercase, 1 lowercase, 1 number
  // Allow common special characters found in browser-generated passwords
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
  return passwordRegex.test(password);
};

// Company name validation
export const isValidCompanyName = (companyName) => {
  // At least 2 characters, alphanumeric and spaces allowed
  return companyName && companyName.trim().length >= 2;
};

// Name validation
export const isValidName = (name) => {
  // At least 2 characters, letters, spaces, hyphens and apostrophes allowed
  const nameRegex = /^[a-zA-Z\s\-']+$/;
  return name && name.trim().length >= 2 && nameRegex.test(name.trim());
};

// Phone number validation (basic)
export const isValidPhoneNumber = (phoneNumber) => {
  // Remove all non-digit characters
  const digitsOnly = phoneNumber.replace(/\D/g, '');
  // Check if it's between 10 and 15 digits
  return digitsOnly.length >= 10 && digitsOnly.length <= 15;
};

// Message validation
export const isValidMessage = (message) => {
  // At least 10 characters
  return message && message.trim().length >= 10;
};

// Generic required field validation
export const isRequired = (value) => {
  return value && value.toString().trim().length > 0;
};

// Length validation
export const hasMinLength = (value, minLength) => {
  return value && value.toString().trim().length >= minLength;
};

export const hasMaxLength = (value, maxLength) => {
  return value && value.toString().trim().length <= maxLength;
};

// Number validation
export const isNumber = (value) => {
  return !isNaN(value) && !isNaN(parseFloat(value));
};

export const isPositiveNumber = (value) => {
  return isNumber(value) && parseFloat(value) > 0;
};

// URL validation
export const isValidURL = (url) => {
  try {
    new URL(url);
    return true;
  } catch (err) {
    return false;
  }
};

// Validation error messages
export const validationMessages = {
  email: 'Please enter a valid email address',
  password: 'Password must be at least 8 characters with uppercase, lowercase, and number',
  companyName: 'Company name must be at least 2 characters',
  name: 'Name must be at least 2 characters and contain only letters, spaces, hyphens, or apostrophes',
  phoneNumber: 'Please enter a valid phone number (10-15 digits)',
  message: 'Message must be at least 10 characters',
  required: 'This field is required',
  minLength: (min) => `This field must be at least ${min} characters`,
  maxLength: (max) => `This field must be no more than ${max} characters`,
  number: 'Please enter a valid number',
  positiveNumber: 'Please enter a positive number',
  url: 'Please enter a valid URL',
  passwordMatch: 'Passwords do not match'
};